var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableHorizontale = function SvgTableHorizontale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4H10V7H7V4ZM5 7V4H2V7H5ZM2 9V12H5V9H2ZM7 9H10V12H7V9ZM12 9V12H14V9H12ZM14 7V4H12V7H14ZM7 2H10H12H14C15.1046 2 16 2.89543 16 4V12C16 13.1046 15.1046 14 14 14H12H10H7H5H2C0.895431 14 0 13.1046 0 12V4C0 2.89543 0.895431 2 2 2H5H7Z"
  })));
};
export default SvgTableHorizontale;